import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Text from 'shopper/components/Text';

import ThreadsListItem from 'components/ThreadsListItem';

import { sendEvent } from 'lib/gtag';

import Pagination from './Pagination';

const ThreadsEmptyList = dynamic(() => import('./ThreadsEmptyList'), {
  ssr: false,
});

const onThreadItemClick = (gaEventCategory) =>
  sendEvent({ category: gaEventCategory, action: 'click_recent_topics' });

const ThreadsList = ({
  basePaginationSlug,
  categoryTitle,
  gaEventCategory,
  threadsPage,
  serverThreads: { threads, total },
}) => {
  if (threads.length === 0) {
    return <ThreadsEmptyList categoryTitle={categoryTitle} />;
  }

  return (
    <Box full>
      <div className="flex justify-end border-b border-neutral-high-200 p-4 dark:border-neutral-low-300">
        <Pagination
          basePaginationSlug={basePaginationSlug}
          gaEventCategory={gaEventCategory}
          threadsPage={threadsPage}
          total={total}
        />
      </div>
      <div className="w-full">
        {threads.map((thread) => (
          <ThreadsListItem
            key={thread.threadId}
            data-test-selector="thread-list-item"
            onClick={() => onThreadItemClick(gaEventCategory)}
            {...thread}
          />
        ))}
        <div className="flex items-center justify-between p-4 md:p-6">
          <Text>
            {threadsPage} de {total} Páginas
          </Text>
          <Pagination
            basePaginationSlug={basePaginationSlug}
            gaEventCategory={gaEventCategory}
            threadsPage={threadsPage}
            total={total}
          />
        </div>
      </div>
    </Box>
  );
};

ThreadsList.propTypes = {
  basePaginationSlug: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  serverThreads: PropTypes.shape({
    total: PropTypes.number.isRequired,
    threads: PropTypes.arrayOf(
      PropTypes.shape({
        threadCategoryId: PropTypes.number,
        threadCategoryName: PropTypes.string,
        threadCategorySlug: PropTypes.string.isRequired,
        threadComments: PropTypes.number.isRequired,
        threadDislikes: PropTypes.number.isRequired,
        threadId: PropTypes.number.isRequired,
        threadLikes: PropTypes.number.isRequired,
        threadPublished: PropTypes.string.isRequired,
        threadReviewed: PropTypes.string,
        threadSlug: PropTypes.string,
        threadSolved: PropTypes.bool.isRequired,
        threadStatus: PropTypes.number.isRequired,
        threadStatusName: PropTypes.string.isRequired,
        threadTitle: PropTypes.string.isRequired,
        threadType: PropTypes.number.isRequired,
        threadTypeName: PropTypes.string.isRequired,
        threadUpdated: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  threadsPage: PropTypes.number.isRequired,
};

export default ThreadsList;
